import { render, staticRenderFns } from "./settingList.vue?vue&type=template&id=102de7ae&scoped=true"
import script from "./settingList.vue?vue&type=script&lang=js"
export * from "./settingList.vue?vue&type=script&lang=js"
import style0 from "./settingList.vue?vue&type=style&index=0&id=102de7ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102de7ae",
  null
  
)

export default component.exports